import { render, staticRenderFns } from "./wholesaleGoods.vue?vue&type=template&id=4fb0d4dd&scoped=true"
import script from "./wholesaleGoods.vue?vue&type=script&lang=js"
export * from "./wholesaleGoods.vue?vue&type=script&lang=js"
import style0 from "./wholesaleGoods.vue?vue&type=style&index=0&id=4fb0d4dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0d4dd",
  null
  
)

export default component.exports